import { useMakeRazorpayPaymentMutation, useVerifyRazorpayPaymentMutation, useGetStudentPaymentByIdQuery } from '../api/razorpayApi';
import { useState, useCallback } from 'react';
import { useRazorpay } from 'react-razorpay';

interface PaymentPayload {
  center_id: number;
  student_id: number;
  amount: number;
  invoice_id: number;
  studentName: string;
  studentEmail: string;
  studentPhone: string;
  onSuccess: (result: any) => void;
  onError: (error: any) => void;
}

export const useRazorpayPayment = () => {
  const [makePayment, { isLoading: isCreating }] = useMakeRazorpayPaymentMutation();
  const [verifyPayment, { isLoading: isVerifying }] = useVerifyRazorpayPaymentMutation();
  const { Razorpay } = useRazorpay();
  
  // State for payment details
  const [paymentId, setPaymentId] = useState<string>('');
  const { data: paymentData, isLoading: isLoadingPayment } = useGetStudentPaymentByIdQuery(
    { id: paymentId }, 
    { skip: !paymentId }
  );

  // console.log(paymentData, '--inHook')

  const startPayment = async ({
    center_id,
    student_id,
    amount,
    invoice_id,
    studentName,
    studentEmail,
    studentPhone,
    onSuccess,
    onError,
  }: PaymentPayload) => {
    try {
      const data: any = await makePayment({ center_id, student_id, amount, invoice_id }).unwrap();

      const options = createRazorpayOptions(data, {
        studentName,
        studentEmail,
        studentPhone,
        onSuccess,
        onError,
      });

      const rzp = new Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error("Error initiating payment:", err);
      onError?.(err);
    }
  };

  const createRazorpayOptions = (data: any, { studentName, studentEmail, studentPhone, onSuccess, onError }: any) => {
    return {
      key: data.payment.razorpay_key,
      amount: data.payment.amount,
      currency: data.payment.currency,
      name: 'ALOHA-TUTION-FEE',
      description: 'Payment for your product',
      order_id: data.payment.id,
      handler: async function (response: any) {
        try {
          const payload = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };
          const result = await verifyPayment({ paymentId: data.payment.payment_id, payload }).unwrap();
          onSuccess?.(result);
        } catch (err) {
          console.error("Error verifying payment:", err);
          onError?.(err);
        }
      },
      prefill: {
        name: studentName || '',
        email: studentEmail || '',
        phone: studentPhone || '',
      },
    };
  };

  const GetStudentPaymentDetails = useCallback((id: string) => {
    if (id) {
      setPaymentId(id);
    }
  }, []);

  return { 
    startPayment, 
    isCreating, 
    isVerifying, 
    GetStudentPaymentDetails,
    paymentDetails: paymentData?.data?.payments || [],
    isLoadingPayment
  };
};
